<template>
  <div>
      <div
          class="modal fade lottery-group-modal"
          id="2d_group_box"
          tabindex="-1"
          role="dialog"
          aria-labelledby="2d-group-modal-title"
          aria-hidden="true"
      >
          <div
              class="modal-dialog modal-dialog-centered modal-sm"
              role="document"
          >
              <div class="modal-content lottery-group-modal__content">
                  <button
                      type="button"
                      class="lottery-group-modal__close"
                      aria-label="Close"
                      data-dismiss="modal"
                  >
                      ×
                  </button>
                  <div class="modal-body p-0">
                      <div class="lottery-group-box">
                          <div class="lottery-group-box__header">
                              <h4
                                  id="2d-group-modal-title"
                                  class="lottery-group-box__title"
                              >
                                  {{
                                      $store.state.language === "en"
                                          ? "Two-D Group"
                                          : "အုပ်စုလိုက်ထိုးမည်"
                                  }}
                              </h4>
                              <p class="lottery-group-box__subtitle">
                                  {{
                                      $store.state.language === "en"
                                          ? "Choose a group pattern to bet quickly."
                                          : "အမြန်ထိုးရန် အုပ်စုပုံစံတစ်ခု ရွေးပါ။"
                                  }}
                              </p>
                          </div>
                          <div class="lottery-group-box__body">
                              <div
                                  class="lottery-group-box__selected"
                                  v-if="selected_data.number_select"
                              >
                                <span>
                                  Selected =
                                  <strong>{{ selected_data.number_select }}</strong>
                                </span>
                                <button
                                  type="button"
                                  class="lottery-group-box__reset"
                                  @click="selected_data.number_select = null"
                                >
                                  <i class="fas fa-redo mr-1"></i>
                                  Reset
                                </button>
                              </div>
                              
                              <div class="lottery-group-box__grid">
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('even_even')"
                                      >{{
                                          $store.state.language === "en" ? "Even Even" : "စုံစုံ"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('odd_odd')"
                                      >{{ $store.state.language === "en" ? "Odd Odd" : "မမ" }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('even_odd')"
                                      >{{ $store.state.language === "en" ? "Even Odd" : "စုံမ" }}
                                  </a>
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('odd_even')"
                                      >{{
                                          $store.state.language === "en" ? "Odd Even" : "မစုံ"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('brother')"
                                      >{{
                                          $store.state.language === "en" ? "Brother" : "ညီကို"
                                      }}</a
                                  >

                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('constellation')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Constellation"
                                              : "နက္ခတ်"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('back_serie')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Back Serie"
                                              : "နောက်စီးရီး"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('only_one')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Only One"
                                              : "တစ်လုံးပါ"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('double')"
                                      >{{ $store.state.language === "en" ? "Double" : "အပူး" }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('double_even')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Double(Even)"
                                              : "စုံပူး"
                                      }}</a
                                  >

                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('double_odd')"
                                      >{{
                                          $store.state.language === "en" ? "Double(Odd)" : "မအပူး"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('brake')"
                                      >{{ $store.state.language === "en" ? "Brake" : "ဘရိတ်" }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('power')"
                                      >{{ $store.state.language === "en" ? "Power" : "ပါဝါ" }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('back_even')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Back Even"
                                              : "နောက်စုံ"
                                      }}</a
                                  >
                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('front_odd')"
                                      >{{
                                          $store.state.language === "en" ? "Front Odd" : "ရှေ့မ"
                                      }}</a
                                  >

                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('back_odd')"
                                      >{{
                                          $store.state.language === "en" ? "Back Odd" : "နောက်မ"
                                      }}</a
                                  >

                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('round_with_double')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Round With Double"
                                              : "အပြီးပေါက်အပူးပါ"
                                      }}</a
                                  >

                                  <a
                                      href="#"
                                      class="lottery-group-box__chip"
                                      @click.prevent="getType('round_without_double')"
                                      >{{
                                          $store.state.language === "en"
                                              ? "Round Without Double"
                                              : "အပြီးပေါက်အပူးမပါ"
                                      }}</a
                                  >
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <!-- === for front serie === -->
          <InputSelectDrawModalVue
              id_type="front_serie"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for back serie === -->
          <InputSelectDrawModalVue
              id_type="back_serie"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for back even === -->
          <InputSelectDrawModalVue
              id_type="back_even"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for front even === -->
          <InputSelectDrawModalVue
              id_type="front_even"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for front odd === -->
          <InputSelectDrawModalVue
              id_type="front_odd"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for back odd === -->
          <InputSelectDrawModalVue
              id_type="back_odd"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === only one === -->
          <InputSelectDrawModalVue
              id_type="only_one"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === brake === -->
          <InputSelectDrawModalVue
              id_type="brake"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for round_without_double === -->
          <InputSelectDrawModalVue
              id_type="round_with_double"
              modalType="round"
              :selected_data="selected_data"
              @type="getInputType"
          />

          <!-- === for round_without_double === -->
          <InputSelectDrawModalVue
              id_type="round_without_double"
              modalType="round"
              :selected_data="selected_data"
              @type="getInputType"
          />
      </div>
  </div>
</template>
<script>
import InputSelectDrawModalVue from './InputSelectDrawModal.vue';

export default {
props: {
  onMyEvent: Function,
  drawTime: String,
},
components: { InputSelectDrawModalVue },
data() {
  return {
    selected_data: {
      number_select: null
    },
    numbers: [],
    allNumbers: [],
  };
},
methods: {
  getInputType(type) {
    // this.selected_data = type.selected_data;
    this.selectNumbers(type.id_type);

    for (let i = 0; i < this.numbers.length; i += 1) {
      this.numbers[i].isSelect = true;
    }

    this.$emit('numbers', this.numbers);
  },
  getType(type) {
    if(!this.selected_data.number_select) {
        $('#'+type).modal('show');
      }
    if(this.selected_data.number_select && this.selected_data.number_select.length > 1 && type !== 'round_with_double' && type !== 'round_without_double') {
      $('#'+type).modal('show');
    }
    this.selectNumbers(type);

    for (let i = 0; i < this.numbers.length; i += 1) {
      this.numbers[i].isSelect = true;
    }

    this.$emit('numbers', this.numbers);
  },
  createDateWithTimeZone() {
    const moment = require('moment-timezone');
    const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
    // Extract individual components from moment object
    const year = dateInTimeZone.year();
    const month = dateInTimeZone.month();
    const day = dateInTimeZone.date();
    const hour = dateInTimeZone.hour();
    const minute = dateInTimeZone.minute();
    const second = dateInTimeZone.second();
    const millisecond = dateInTimeZone.millisecond();

    // Create a new Date object with the extracted components
    const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
    return newDateObject;
  },
  // setAmount(amount) {
  //   const currentHour = this.createDateWithTimeZone().getHours();
  //   const draw = currentHour < 12 ? '12:00' : '4:30';
  //   for (let i = 0; i < this.numbers.length; i += 1) {
  //     this.numbers[i].solo_amount = amount;
  //     this.numbers[i].draw = draw;
  //   }
  // },
  selectNumbers(type) {
  //   for (let i = 0; i < this.allNumbers.length; i += 1) {
  //     this.allNumbers[i].isSelect = false;
  //   }

    switch (type) {
      case 'even_even':
        this.numbers = this.allNumbers.filter(
          (el) => parseInt(el.number, 10) % 2 === 0
                          && Math.floor(parseInt(el.number, 10) / 10) % 2 === 0,
        );
        break;
      case 'odd_odd':
        this.numbers = this.allNumbers.filter(
          (el) => parseInt(el.number, 10) % 2 !== 0
                          && Math.floor(parseInt(el.number, 10) / 10) % 2 !== 0,
        );

        break;
      case 'even_odd':
        this.numbers = this.allNumbers.filter(
          (el) => parseInt(el.number, 10) % 2 !== 0
                          && Math.floor(parseInt(el.number, 10) / 10) % 2 === 0,
        );
        break;
      case 'odd_even':
        this.numbers = this.allNumbers.filter(
          (el) => el.number % 2 === 0
                          && Math.floor(parseInt(el.number, 10) / 10) % 2 !== 0,
        );

        break;
      case 'double':
        this.numbers = this.allNumbers.filter((el) => {
          const lastChar = el.number.toString().slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          return (
            Math.floor(parseInt(el.number, 10) / 10)
                          === lastDigit
          );
        });

        break;
      case 'double_even':
        this.numbers = this.allNumbers.filter((el) => {
          const lastChar = el.number.toString().slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          return (
            Math.floor(parseInt(el.number, 10) / 10) % 2
                              === 0
                          && Math.floor(parseInt(el.number, 10) / 10)
                              === lastDigit
          );
        });

        break;
      case 'double_odd':
        this.numbers = this.allNumbers.filter((el) => {
          const toText = el.number.toString().toString();
          const lastChar = toText.slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          return (
            Math.floor(parseInt(el.number, 10) / 10) % 2
                              !== 0
                          && Math.floor(parseInt(el.number, 10) / 10)
                              === lastDigit
          );
        });

        break;
      case 'power':
        this.numbers = this.allNumbers.filter(
          (el) => parseInt(el.number, 10) === 5
                          || parseInt(el.number, 10) === 50
                          || parseInt(el.number, 10) === 16
                          || parseInt(el.number, 10) === 61
                          || parseInt(el.number, 10) === 27
                          || parseInt(el.number, 10) === 72
                          || parseInt(el.number, 10) === 38
                          || parseInt(el.number, 10) === 83
                          || parseInt(el.number, 10) === 49
                          || parseInt(el.number, 10) === 94,
        );

        break;
      case 'constellation':
        this.numbers = this.allNumbers.filter(
          (el) => parseInt(el.number, 10) === 96
                          || parseInt(el.number, 10) === 7
                          || parseInt(el.number, 10) === 70
                          || parseInt(el.number, 10) === 18
                          || parseInt(el.number, 10) === 81
                          || parseInt(el.number, 10) === 24
                          || parseInt(el.number, 10) === 42
                          || parseInt(el.number, 10) === 35
                          || parseInt(el.number, 10) === 53
                          || parseInt(el.number, 10) === 69,
        );

        break;
      case 'brother':
        this.numbers = this.allNumbers.filter(
          (el) => parseInt(el.number, 10) === 12
                          || parseInt(el.number, 10) === 23
                          || parseInt(el.number, 10) === 34
                          || parseInt(el.number, 10) === 45
                          || parseInt(el.number, 10) === 56
                          || parseInt(el.number, 10) === 67
                          || parseInt(el.number, 10) === 78
                          || parseInt(el.number, 10) === 89
                          || parseInt(el.number, 10) === 90
                          || parseInt(el.number, 10) === 9
                          || parseInt(el.number, 10) === 98
                          || parseInt(el.number, 10) === 87
                          || parseInt(el.number, 10) === 76
                          || parseInt(el.number, 10) === 65
                          || parseInt(el.number, 10) === 54
                          || parseInt(el.number, 10) === 43
                          || parseInt(el.number, 10) === 32
                          || parseInt(el.number, 10) === 21
                          || parseInt(el.number, 10) === 10
                          || parseInt(el.number, 10) === 1,
        );

        break;
      case 'front_serie':
        if (!this.selected_data.number_select) $('#front_serie').modal('show');
        else $('#front_serie').modal('hide');

        this.numbers = this.allNumbers.filter((el) => {
          if (
            this.selected_data.number_select === '0'
                          && typeof el.number === 'string'
          ) {
            return el.number;
          }
          return (
            Math.floor(el.number / 10)
                          === this.selected_data.number_select
          );
        });

        this.selected_data = {};
        break;

      case 'back_odd':
        this.numbers = this.allNumbers.filter((el) => {
          if (
            this.selected_data.number_select === '0'
                          && typeof el.number === 'string'
                          && parseInt(el.number, 10) % 2 !== 0
          ) {
            return el.number;
          }
          return (
            Math.floor(el.number / 10)
                              === this.selected_data.number_select
                          && el.number % 2 !== 0
          );
        });

        break;
      case 'back_even':
        this.numbers = this.allNumbers.filter((el) => {
          if (
            this.selected_data.number_select === '0'
                          && typeof el.number === 'string'
                          && parseInt(el.number, 10) % 2 === 0
          ) {
            return el.number;
          }
          return (
            Math.floor(el.number / 10)
                              === this.selected_data.number_select
                          && el.number % 2 === 0
          );
        });

        break;
      case 'back_serie':
        this.numbers = this.allNumbers.filter((el) => {
          const toText = el.number.toString();
          const lastChar = toText.slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          return (
            parseInt(this.selected_data.number_select, 10)
                          === lastDigit
          );
        });

        break;
      case 'front_even':
        this.numbers = this.allNumbers.filter((el) => {
          const toText = el.number.toString();
          const lastChar = toText.slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          return (
            parseInt(this.selected_data.number_select, 10)
                              === lastDigit
                          && Math.floor(parseInt(el.number, 10) / 10) % 2 === 0
          );
        });

        break;
      case 'front_odd':
        this.numbers = this.allNumbers.filter((el) => {
          const toText = el.number.toString();
          const lastChar = toText.slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          return (
            parseInt(this.selected_data.number_select, 10)
                              === lastDigit
                          && Math.floor(el.number / 10) % 2 !== 0
          );
        });

        break;
      case 'only_one':
        this.numbers = this.allNumbers.filter((el) => el.number
          .toString()
          .includes(this.selected_data.number_select));

        break;

      case 'brake':
        if(!this.selected_data.number_select) {
          $("#brake").modal('show');
        }
        this.numbers = this.allNumbers.filter((el) => {
          const toText = el.number.toString();
          const lastChar = toText.slice(-1);
          const lastDigit = parseInt(lastChar, 10);
          const total = Math.floor(parseInt(el.number, 10) / 10)
                          + lastDigit;

          if (
            total.toString().length > 1
                          && this.selected_data.number_select === 1
          ) {
            const toTextTotal = total.toString();
            const lastCharTotal = toTextTotal.slice(-1);
            const lastDigitTotal = parseInt(lastCharTotal, 10);
            return (
              lastDigitTotal
                              === this.selected_data.number_select
            );
          }
          return total
            .toString()
            .includes(this.selected_data.number_select);
        });

        break;
      case 'round_with_double':
        this.numbers = this.allNumbers.filter((el) => {
          const newArray = this.selected_data.number_select
            .toString(10)
            .split('')
            .map((t) => t);

          const toText = el.number.toString();
          const lastChar = toText.slice(-1);
          let lastFilter = null;
          let firstFilter = null;

          for (let i = 0; i < newArray.length; i += 1) {
            if (newArray[i] === lastChar) {
              lastFilter = true;
            }
          }
          const firstChar = Math.floor(
            parseInt(el.number, 10) / 10,
          );
          for (let j = 0; j < newArray.length; j += 1) {
            if (newArray[j] === firstChar.toString()) {
              firstFilter = true;
            }
          }

          return firstFilter && lastFilter;
        });

        break;
      case 'round_without_double':
        this.numbers = this.allNumbers.filter((el) => {
          const newArray = this.selected_data.number_select
            .toString(10)
            .split('')
            .map((t) => t);

          const toText = el.number.toString();
          const lastChar = toText.slice(-1);
          let lastFilter = null;
          let firstFilter = null;

          // Math.floor(parseInt(el.number, 10) / 10)
          for (let i = 0; i < newArray.length; i += 1) {
            if (newArray[i] === lastChar) {
              lastFilter = true;
            }
          }
          const firstChar = Math.floor(
            parseInt(el.number, 10) / 10,
          );
          for (let j = 0; j < newArray.length; j += 1) {
            if (newArray[j] === firstChar.toString()) {
              firstFilter = true;
            }
          }

          return (
            firstFilter
                          && lastFilter
                          && firstChar.toString() !== lastChar
          );
        });

        break;
      default:
        break;
    }
  },
  async fetchNumbers() {
    try {
        const res = await axios.post('/twod_numbers', {
          limit: 'all',
          draw: this.drawTime
        },{
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          });
        this.$store.commit('setTwodnumbers', res.data.data);
        console.log(res)
        this.allNumbers = res.data.data;
        this.numbers = res.data.data;
      } catch (error) {
        console.log(error);
      }
  },
},
mounted() {
  this.fetchNumbers();
  this.onMyEvent(() => {
    this.numbers = [];
  });
},
};
</script>
<style scoped>
.lottery-group-box {
  background: #FFFFFF;
}

.lottery-group-box__header {
  background: #0D3B1A;
  padding: 1.1rem 1.25rem 1rem;
  text-align: center;
}

.lottery-group-box__title {
  margin: 0;
  color: #FFFFFF !important;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.35;
}

.lottery-group-box__subtitle {
  margin: 0.45rem 0 0;
  color: #FFFFFF !important;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.4;
}

.lottery-group-box__body {
  padding: 1rem;
  background: #FFFFFF;
}

.lottery-group-box__selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  padding: 0.65rem 0.8rem;
  background: #F5F7F5;
  border: 1px solid rgba(13, 59, 26, 0.12);
  border-radius: 10px;
  color: #0D3B1A;
  font-size: 0.85rem;
  font-weight: 600;
}

.lottery-group-box__selected strong {
  color: #D32F2F;
  font-size: 1rem;
}

.lottery-group-box__reset {
  border: none;
  background: transparent;
  color: #0D3B1A;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.lottery-group-box__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.lottery-group-box__chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0.45rem 0.8rem;
  border-radius: 10px;
  border: 1.5px solid rgba(13, 59, 26, 0.22);
  background: #F5F7F5;
  color: #0D3B1A !important;
  font-size: 0.85rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none !important;
  line-height: 1.25;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.lottery-group-box__chip:hover {
  background: #0D3B1A;
  border-color: #0D3B1A;
  color: #FFFFFF !important;
}
</style>
